module.exports = __webpack_public_path__ + "static/media/jimmy@3x.d99e5b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/jimmy@3x.png
// module id = 258
// module chunks = 1